// Component Imports
import LayoutFooter from '../../../@layouts/components/horizontal/Footer';
import { HorizontalFooterContent } from './FooterContent';

export const HorizontalFooter = () => {
  return (
    <LayoutFooter>
      <HorizontalFooterContent />
    </LayoutFooter>
  );
};
